export const POST_SALE_DASHBOARD_PATH = '/post-sale-dashboard';
